import { render, staticRenderFns } from "./rightBottom.vue?vue&type=template&id=c3f96716&scoped=true"
import script from "./rightBottom.vue?vue&type=script&lang=js"
export * from "./rightBottom.vue?vue&type=script&lang=js"
import style0 from "./rightBottom.vue?vue&type=style&index=0&id=c3f96716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f96716",
  null
  
)

export default component.exports